import * as React from "react";
import { connect } from "react-redux";

import {
  GiftingHistory as GiftingHistoryComponent,
  GiftingHistoryProps,
} from "../../components/GiftingHistory/GiftingHistory";

class GiftingHistory extends React.Component<GiftingHistoryProps> {
  render() {
    return <GiftingHistoryComponent {...this.props} />;
  }
}

export default connect(null, {})(GiftingHistory);
